Modules.EmailSubscription.Application = require('../../email_subscription/frontend/application');

if (window.Coupons == null) {
  window.Coupons = {};
}

$(function() {
  var isSharedCoupon, pu, ref, revealAllCodes;
  if ((ref = Groupon.EmailSubscription) != null ? ref.enableCouponsEmailAlerts : void 0) {
    Modules.EmailSubscription.Application.initializeCouponsEmailAlerts();
  }
  Coupons.clonePlaceholderText = function(el) {
    var text;
    text = $(el).attr('placeholder');
    return $(el).val(text);
  };
  Coupons.checkHash = function() {
    var coupon;
    if (document.location.hash !== '') {
      coupon = document.location.hash.split('#')[1];
      return Coupons.showCouponCodeModal(coupon);
    }
  };
  Coupons.showHiwModal = function(e) {
    Groupon.Utils.lazyLoadImages();
    GIG.Modal.open({
      el: $('#hiwModal')
    });
    return false;
  };
  isSharedCoupon = function() {
    var query;
    query = window.location.search.slice(1);
    if (query.indexOf("s=1") !== -1) {
      return true;
    }
  };
  Coupons.showCouponCodeModal = function(coupon) {
    var couponModal, couponsBaseUrl, couponsContent, data, searchParams, url, xhr;
    if (!((coupon != null) && coupon.indexOf("-") > -1)) {
      return false;
    }
    $('#couponModal').remove();
    couponsContent = $('body.modable');
    couponModal = $('#couponModal') || $('<div id="#couponModal" class="modal"></div>');
    if (!((Coupons.getQueryParam('c') != null) || (Coupons.getQueryParam('ph') != null))) {
      url = new URL(window.location.href);
      searchParams = new URLSearchParams(url.search.slice(1));
      searchParams.append("c", coupon);
      url.search = searchParams;
      history.pushState(null, null, url);
    }
    data = _.pick(Coupons.getQueryParam(), 'alt', 's', 'utm_source', 'utm_medium', 'strategy');
    couponsBaseUrl = $('.coupons-nav').data('coupons-base-url');
    xhr = $.ajax({
      url: couponsBaseUrl + "/" + coupon,
      data: data,
      dataType: 'html'
    });
    xhr.done(function(html) {
      var couponId, ref1;
      couponModal = $(html).appendTo(couponsContent);
      if (couponModal == null) {
        return false;
      }
      GIG.Modal.open({
        el: couponModal
      });
      GIG.Modal.onClose(function() {
        url = location.href.replace("c=" + (Coupons.getQueryParam('c')), '');
        if (url.slice(-1) === '?') {
          url = url.slice(0, -1);
        }
        return history.replaceState(null, null, url);
      });
      couponId = coupon;
      coupon = {
        title: $('#couponModal').data('coupon-title'),
        merchant: $('#couponModal').data('merchant-name'),
        image: $('#couponModal img.merchant-logo').attr('src'),
        couponId: couponId
      };
      Coupons.couponShareOptions(coupon);
      revealAllCodes();
      if ($('html').hasClass('lt-ie9')) {
        Coupons.replaceCopyButton();
      } else {
        Coupons.initClipboard();
      }
      if ((ref1 = Groupon.EmailSubscription) != null ? ref1.enableCouponsEmailAlerts : void 0) {
        Modules.EmailSubscription.Application.initializeCouponsEmailAlerts();
      }
      Coupons.autoRedirect();
      if ($("html").hasClass('lt-ie10')) {
        Coupons.clonePlaceholderText('.subscribe-email');
        false;
      }
      return false;
    });
    return false;
  };
  Coupons.initClipboard = function(e) {
    var code, i, j, len, promoCodes, ref1, results, tooltip, tooltipContent;
    ZeroClipboard.setDefaults({
      moviePath: "/coupons/images/zeroclipboard.swf",
      zIndex: '9',
      forceHandCursor: true
    });
    Coupons.clipboard = new ZeroClipboard($(".copy-button"));
    tooltip = $('#copy-code-tooltip');
    tooltipContent = $(tooltip).find('.tooltip-content');
    Coupons.clipboard.addEventListener('onMouseOut', function(e) {
      var ref1;
      if (!(typeof GIG !== "undefined" && GIG !== null ? (ref1 = GIG.Modal) != null ? ref1.currentOpenModal().length : void 0 : void 0)) {
        return GIG.Tooltip.close(tooltip);
      }
    });
    Coupons.clipboard.on("load", function(client) {
      return Coupons.clipboard.on("complete", function(client, args) {
        var button, id, ref1;
        $(this).click();
        id = client.htmlBridge.previousSibling.id;
        if (/couponModal/i.test(id)) {
          if (typeof GIG !== "undefined" && GIG !== null ? (ref1 = GIG.Modal) != null ? ref1.currentOpenModal().length : void 0 : void 0) {
            Coupons.replaceCopyButton();
            return $('.copy-notice').fadeIn();
          } else {
            return $(tooltipContent).text($(tooltipContent).data('text-copied'));
          }
        } else {
          button = $(this);
          button.addClass('pulse-color');
          return button.find('span').text('Copied!');
        }
      });
    });
    Coupons.clipboard.on("noflash", function(client, args) {
      return Coupons.replaceCopyButton();
    });
    promoCodes = [];
    ref1 = $("div.copy-button");
    results = [];
    for (i = j = 0, len = ref1.length; j < len; i = ++j) {
      code = ref1[i];
      promoCodes[i] = new ZeroClipboard(code);
      results.push(promoCodes[i].addEventListener('onMouseOver', function(e) {
        var ref2;
        if (!(typeof GIG !== "undefined" && GIG !== null ? (ref2 = GIG.Modal) != null ? ref2.currentOpenModal().length : void 0 : void 0)) {
          $(tooltipContent).text($(tooltipContent).data('text-copy'));
          return $(this).trigger("zeroclipboard-hover");
        }
      }));
    }
    return results;
  };
  revealAllCodes = function() {
    return $('.reveal-code, .show-coupon-modal').show();
  };
  Coupons.replaceCopyButton = function() {
    var button, text, url;
    url = $('#couponModal a.copy-button').attr('href');
    text = $('#couponModal .code.row').attr('data-buttontext');
    button = '<a href="' + url + '" class="btn-cta affiliate-direct unselectable" target="_blank" data-bhw="ShopOnlineButton" rel="nofollow">' + text + '</a>';
    return $('#couponModal a.copy-button').replaceWith(button);
  };
  Coupons.checkBrokenImages = function() {
    return $('.image-contain img').bind("error", function(e) {
      var el, text;
      text = $(this).attr('alt').split(' coupons')[0];
      if (text === '') {
        this.src = "https://img.grouponcdn.com/coupons/vappJKPuiU1JVJiHjsot/bc-500x500.gif";
        return false;
      }
      el = '<p>' + text + '</p>';
      $(this).replaceWith(el);
    });
  };
  Coupons.makePage = function(src) {
    return "<html>\n" + "<head>\n" + ("<title>" + (I18n.t('js.modules.coupons.print_coupon_title')) + "</title>\n") + "<script>\n" + "function step1() {\n" + " setTimeout('step2()', 1000);\n" + "}\n" + "function step2() {\n" + " window.print();\n" + " window.close();\n" + "}\n" + "</scr" + "ipt>\n" + "</head>\n" + "<body onLoad='step1()'>\n" + "<img src='" + src + "'/>\n" + "</body>\n" + "</html>\n";
  };
  Coupons.printCoupon = function(evt) {
    var link, popup, src;
    src = $('.printable-image').attr('data-url');
    link = "about:blank";
    popup = window.open(link, "_new");
    popup.document.open();
    popup.document.write(Coupons.makePage(src));
    popup.document.close();
    return false;
  };
  Coupons.nextPagedListing = (function() {
    var initialPage, nextPage, pageSize;
    initialPage = parseInt(Coupons.getQueryParam('page'), 10) || 0;
    nextPage = initialPage;
    pageSize = void 0;
    return function(e) {
      var couponList, nextPageUrl, pagination, shownSoFar, total, xhr;
      nextPage += 1;
      nextPageUrl = window.location.pathname + "?page=" + nextPage;
      couponList = $('#coupons-list');
      if (pageSize == null) {
        pageSize = couponList.find('.coupon.row').length;
      }
      pagination = $('.pagination');
      shownSoFar = parseInt($('.pagination p').data('size'), 10);
      total = parseInt(pagination.find('p').data('total'), 10);
      xhr = $.get(nextPageUrl, function(data) {
        var count, couponWord, remaining, showingText, text, whatsLeft, wrapped_data;
        wrapped_data = "<div class='ajax-coupons'>" + data + "</div>";
        couponList.find('.coupon').last().after(wrapped_data);
        couponList.find('.coupon .should-truncate').dotdotdot();
        count = couponList.find('.coupon-wrapper').length;
        remaining = pageSize;
        whatsLeft = total - count;
        if (whatsLeft < pageSize) {
          remaining = whatsLeft;
        }
        couponWord = remaining === 1 ? I18n.t('js.modules.coupons.coupon_word') : I18n.t('js.modules.coupons.coupons_word');
        text = I18n.t('js.modules.coupons.see_more', {
          remaining: remaining,
          spanPrev: "<span class='remaining'>",
          spanPost: "</span>"
        }) + couponWord;
        text = $('<div/>').html(text).text();
        $('.pagination a.more-coupons').html(text);
        showingText = I18n.t('js.modules.coupons.showing_text', {
          size: count,
          total: total
        });
        pagination.find('p.showing').html(showingText);
        pagination.find('span.remaining').html(remaining);
        if (whatsLeft === 0) {
          return pagination.find('a.more-coupons').remove();
        }
      });
      xhr.done(function() {
        var element, options;
        Coupons.checkBrokenImages();
        GIG.Utils.truncateElements(element = $('.ajax-coupons:last-child'), options = {});
        $('span.text.should-truncate').trigger("isTruncated", function(isTruncated) {
          if (isTruncated) {
            return $(this).parent().find('span.icon-arrow-down').show();
          }
        });
        $('.pagination a.more-coupons').removeClass('avoid-clicks');
        window.Groupon.Utils.lazyLoadImages();
      });
      return false;
    };
  })();
  Coupons.checkLightboxParams = function() {
    var coupon;
    coupon = Coupons.getQueryParam('ph') || Coupons.getQueryParam('c');
    if (coupon != null) {
      Coupons.showCouponCodeModal(coupon);
      false;
    }
    Coupons.checkHash();
    return false;
  };
  Coupons.requestFilteredCoupons = function(event) {
    var couponContainer, filter, filterUrl, loadingHtml, xhr;
    couponContainer = $('#coupon-container');
    filter = $(event.currentTarget).attr('data-filter');
    filterUrl = "" + window.location.pathname + filter;
    loadingHtml = '<div id="coupon-loading-overlay"><img src="https://img.grouponcdn.com/coupons/76fdkYRtVsQRvh9wfjYw/Qb-64x66.gif" /></div>';
    couponContainer.prepend(loadingHtml);
    if (filter === "") {
      $('.pagination').show();
    } else {
      $('.pagination').hide();
    }
    xhr = $.get(filterUrl, function(data) {
      return couponContainer.find('#coupons-list').html(data);
    });
    xhr.done(function() {
      var element, options;
      GIG.Utils.truncateElements(element = document.body, options = {});
      $('span.text.should-truncate').trigger("isTruncated", function(isTruncated) {
        if (isTruncated) {
          return $(this).parent().find('span.icon-arrow-down').show();
        }
      });
      return setTimeout((function() {
        return $('#coupon-loading-overlay').remove();
      }), 500);
    });
    return false;
  };
  pu = function(w) {
    var A, B, C, x, y, z;
    y = $("<a />").attr("href", w);
    y = y.appendTo(document.body).get(0);
    C = document.createEvent("MouseEvents");
    B = true;
    z = false;
    x = false;
    A = true;
    C.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, B, z, x, A, 0, null);
    y.dispatchEvent(C);
    y.parentNode.removeChild(y);
    return false;
  };
  return Coupons.affiliatePopunder = function(affiliateUrl, couponModalUrl) {
    var b, myWindow, selfClosingUrl, windowFeatures;
    b = navigator.BrowserDetect[0];
    windowFeatures = "width=400,height=600,top=100,left=200,menubar=yes,location=yes,resizable=yes,scrollbars=yes";
    if (b === 'Safari' || b === 'Chrome') {
      myWindow = window.open(affiliateUrl, "myWindow", windowFeatures);
      selfClosingUrl = "data:text/html,<title>" + (I18n.t('js.modules.coupons.closing_window')) + "</title><script>window.close();<\/script>";
      if (b === 'Safari') {
        pu(selfClosingUrl);
      }
      window.focus();
    } else if (b === 'Firefox' || b === 'MSIE') {
      myWindow = window.open(affiliateUrl, "myWindow", windowFeatures);
      myWindow.blur();
      myWindow.opener.window.open("", "_self", "");
      myWindow.opener.window.focus();
    } else {
      Coupons.popAffiliateLink(couponModalUrl, affiliateUrl);
    }
    return false;
  };
});

$(window).load(function() {
  return Groupon.Performance.pageReady();
});

$(function() {
  var element, options;
  Coupons.checkBrokenImages();
  GIG.Utils.truncateElements(element = document.body, options = {
    watch: true
  });
  Coupons.checkLightboxParams();
  $(document).on('click', '.accordion .wrapper', function() {
    return $('.accordion .wrapper').toggleClass('expand');
  });
  $('a#hiwModalTrigger').on('click', Coupons.showHiwModal);
  $(document).on('click', '.btn-printable', Coupons.printCoupon);
  $(document).on('click', '#couponModal .code input', function() {
    return $(this).select();
  });
  $(document).on('click', '.show-hidden-code a', function() {
    var affiliateUrl, couponUrl;
    affiliateUrl = $(this).attr('data-affiliateurl');
    couponUrl = $(this).attr('href');
    window.open(couponUrl, '_blank');
    window.open(affiliateUrl, '_self');
    return false;
  });
  $('#coupon-filters div.filter').on('click', function(e) {
    var clickedOn;
    $('#coupon-loading-overlay').show();
    clickedOn = $(e.currentTarget || e.srcElement);
    Coupons.requestFilteredCoupons(e);
    $('#coupon-filters div.filter').addClass('inactive').removeClass('active');
    clickedOn.removeClass('inactive').addClass('active');
    return false;
  });
  $(document).on("click", "#show-all-coupons", function(e) {
    Coupons.requestFilteredCoupons(e);
    $('#coupon-filters div.filter').removeClass('active');
    return $('#coupon-filters div.filter.all-coupons').addClass('active');
  });
  $('.pagination a.more-coupons').on('click', function(e) {
    var error, spinner;
    error = $('.coupons-error');
    if (error.length > 0) {
      error.remove();
    }
    $('.pagination a.more-coupons').addClass('avoid-clicks');
    spinner = '<img src="https://img.grouponcdn.com/coupons/qV7xFPYRbX8yv6wX56rs/Sa-32x32.gif" />';
    $('a.more-coupons').html('<span class="loading-text">' + I18n.t('js.modules.coupons.loading') + '</span>' + spinner);
    Coupons.nextPagedListing();
    return false;
  });
  $(document).on('click', '.lt-ie10 .subscribe-email', function(e) {
    return $('.subscribe-email').val('');
  });
  $('#popular-stores-categories a.show-more-popular-stores').on("click", function(e) {
    $('#more-popular-stores-categories').show();
    $('#popular-stores-categories a.show-less-popular-stores').show();
    return $(this).hide();
  });
  return $('#popular-stores-categories a.show-less-popular-stores').on("click", function(e) {
    $('#more-popular-stores-categories').hide();
    $('#popular-stores-categories a.show-more-popular-stores').show();
    return $(this).hide();
  });
});

